import { render, staticRenderFns } from "./ThemsSwitcher.vue?vue&type=template&id=f04a2aee&scoped=true"
import script from "./ThemsSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemsSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04a2aee",
  null
  
)

export default component.exports